"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeSchema = exports.placeInitalized = void 0;
const joi_1 = __importDefault(require("joi"));
const config_1 = require("../config");
const joiMessages_1 = require("../data/joiMessages");
const validations_1 = require("../data/validations");
exports.placeInitalized = {
    name: '',
    email: '',
    ssn: '',
    refundProcess: '',
    testPayment: true,
    phone: '',
    subscription: '',
    active: true,
    allowOnlyAuthorizedTap: false,
    image: {
        image: '',
        type: ''
    },
    paymentProvider: '',
    identifier: '',
    fireID: '',
    posProvider: '',
    allowManualCredit: false,
    username: '',
    password: '',
    country: '',
    currency: '',
    placeUsers: [],
};
// -- SCHEMA -- //
exports.placeSchema = joi_1.default.object({
    name: joi_1.default.any().allow(''),
    subscription: joi_1.default.any().allow(''),
    phone: joi_1.default.any().allow(''),
    active: joi_1.default.boolean(),
    identifier: joi_1.default.any().allow(''),
    allowOnlyAuthorizedTap: joi_1.default.boolean(),
    testPayment: joi_1.default.boolean(),
    allowManualCredit: joi_1.default.boolean(),
    username: joi_1.default.any().allow(''),
    refundProcess: joi_1.default.any().allow(''),
    timezone: joi_1.default.any().allow(''),
    timezoneNumber: joi_1.default.any().allow(''),
    posProvider: joi_1.default.any().allow(''),
    currency: joi_1.default.any().allow(''),
    country: joi_1.default.any().allow(''),
    password: joi_1.default.any().allow(''),
    fireID: joi_1.default.string().allow(''),
    paymentProvider: joi_1.default.string().valid(config_1.APP_TYPES.paymentProviders.Rapyd, config_1.APP_TYPES.paymentProviders.Valitor, config_1.APP_TYPES.paymentProviders.Teya).allow(''),
    // company admin
    ssn: joi_1.default.string().optional().allow('').messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'SSN' }),
    }),
    email: joi_1.default.string().allow('').pattern(validations_1.emailRegex).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Email', patternText: 'has to be valid email' }),
    }),
    image: joi_1.default.any().optional(),
    placeUsers: joi_1.default.any().allow(''),
});
